
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'DLabel',
  props: {
    label: {
      type: String,
      required: true
    },
    color: {
      type: String,
      default: 'ink',
      validator: (value: string) =>
        ['cherry', 'honey', 'banana', 'ink', 'juniper', 'aqua', 'snow'].includes(value)
    }
  }
})
